import { evaluateQantity, showNotification } from '@/services/calculate'
import { formatNumber } from '@/services/convert'

export const socketEvents = {
  error: 'Error',
  templateClone: 'TemplateCloned',
  templateSideBarUpdated: 'TemplateSideBarUpdated',
  templateInteriorGroupAdded: 'TemplateInteriorGroupAdded',
  templateInteriorGroupDeleted: 'TemplateInteriorGroupDeleted',
  templateTenantBankAdded: 'TemplateTenantBankAdded',
  templateTenantAdded: 'TemplateTenantadded',
  templateIntegrated: 'TemplateApplied',
  tenantApproachUpdated: 'TenantApporachUpdated',
  templateTakeoffDetailsUpdated: 'TemplateTakeoffDetailsUpdated',
  areaofBuildingFootprint: 'AreaofBuildingFootprintUpdated',
  areaofTotalBuilding: 'AreaofTotalBuildingUpdated',
  numberofStoriesUpdated: 'NumberofStoriesUpdated',
  perimeterBuildingFootprintUpdated: 'PerimeterBuildingFootprintUpdated',
  averageStoryHeightUpdated: 'AverageStoryHeightUpdated',
  tenantSFUpdated: 'TenantSFUpdated',
  projectCloned: 'ProjectCloned',
  projectAssetCloned: 'AssetCloned',
  projectAssetDeleted: 'ProjectAssetDeleted',
  projectSidebarUpdated: 'ProjectSideBarUpdated',
  projectTenantBankAdded: 'TenantBankApplied',
  projectTenantAdded: 'ProjectTenantadded',
  projectTenantInfoDeleted: 'ProjectTenantInfoDeleted',
  projectInteriorGroupAdded: 'ProjectInteriorGroupAdded',
  ProjectInteriorGroupUpdated: 'ProjectInteriorGroupUpdated',
  projectInteriorGroupDeleted: 'ProjectInteriorGroupDeleted',
  projectTakeoffDetailsUpdated: 'ProjectTakeoffDetailsUpdated',
  projectTakeoffInserted: 'ProjectTakeoffInserted',
  projectTakeoffDeleted: 'ProjectTakeoffDeleted',
  assetTakeOffUpdated: 'AssetTakeOffUpdated',
  syncProjectDetails: 'SyncProjectDetails',
  cloneInteriorInfo: 'InteriorInfoCloned',
  cloneProjectSpecialityInfo: 'CommonAreaCloned',
  cloneProjectSiteTakeoff: 'SiteTakeoffCloned',
  cloneProjectBuildingShell: 'BuildingShellCloned',
  cloneProjectBuildingGeneral: 'BuildinGeneralCloned',
  updateVarianceFactor: 'UpdateVarianceFactor',
  pisDateUpdated: 'PisDateUpdated',
  locationFactorUpdated: 'LocationFactorUpdated',
  constructionQualityFactorUpdated: 'ConstructionQualityFactorUpdated',
  conditionFactorUpdated: 'ConditionFactorUpdated',
  takeoffUpdated: 'TakeoffUpdated',
  quantityUpdated: 'QuantityUpdated',
  unitCostUpdated: 'UnitCostUpdated',
  quantityPercentageUpdated: 'QuantityPercentageUpdated',
  areaUpdated: 'AreaUpdated',
  contractUpdated: 'ContractUpdated',
  categoryCodeUpdated: 'CategoryCodeUpdated',
  usersSynced: 'UsersSynced',
  fileDownloaded: 'FileDownloaded',
  bulkUpdates: 'BulkUpdates',
  fileUploaded: 'FileUploaded',
  fileExported: 'FileExported',
  fileImported: 'FileImported',
  bankAreaUpdated: 'BankAreaUpdated',
  perimeterUpdated: 'PerimeterUpdated',
  analysisSheetUpdated: 'AnalysisSheetUpdated',
  assetDetailsLinked: 'AssetDetailsLinked',
  assetSaveAsTemplate: 'AssetSaveAsTemplate',
  linkMethodUpdated: 'LinkMethodUpdated',
  linkAsset: 'LinkAsset',
  unlinkedAsset: 'UnlinkedAsset',
  buildingGeneralUpdated: 'BuildingGeneralUpdated',
  buildingShellUpdated: 'BuildingShellUpdated',
  interiorInfoUpdated: 'InteriorInfoUpdated',
  commonAreaUpdated: 'CommonAreaUpdated',
  siteTakeoffUpdated: 'SiteTakeoffUpdated',
  reportAssetClassUpdated: 'ReportAssetClassUpdated',
  CloneTenant: 'CloneTenant',
  takeoffAdjustmentCostUpdated: 'TakeoffAdjustmentCostUpdated',
  copyApplicationMasterData: 'CopyApplicationMasterData',
  estimateTakeoffTrendedCostUpdated: 'EstimateTakeoffTrendedCostUpdated',
  takeoffMoved: 'TakeoffMoved',
  tileMoved: 'TileMoved',
  estimateTakeoffUpdated: 'EstimateTakeoffUpdated',
  takeoffReconcile: 'TakeoffReconcile',
  generateReport: 'GenerateReport',
  projectArchived: 'ProjectArchived',
  projectUnArchived: 'ProjectUnArchived',
  reportMethodUpdated: 'ReportMethodUpdated',
  reportConventionUpdated: 'ReportConventionUpdated',
}

export const templateColumns = [
  {
    aggFunc: null,
    colId: 'display',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: '0',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: 'isLocked',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: '1',
    flex: null,
    hide: false,
    pinned: null,
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    header: 'Suite #',
    colId: 'suite',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Tenant',
    colId: 'tenant',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Contract',
    colId: 'contract',
    width: 100,
    hide: false,
    pinned: null,
    sort: 'asc',
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Contract Name',
    colId: 'contractName',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Category Code',
    colId: 'categoryCode',
    width: 100,
    hide: false,
    pinned: null,
    sort: 'asc',
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Category Code Description',
    colId: 'categoryCodeDescription',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Asset Class',
    colId: 'assetClass',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Takeoff Grouping',
    colId: 'takeoffGrouping',
    width: 200,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Group',
    colId: 'interiorGroup',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Additional Description',
    colId: 'additionalDescription',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Takeoff Description',
    colId: 'takeoff',
    width: 400,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Calculation',
    aggFunc: null,
    colId: 'calculation',
    flex: null,
    hide: false,
    pinned: null,
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 100,
    display: true,
  },
  {
    header: 'Group Quantity',
    colId: 'groupQuantity',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Quantity',
    colId: 'quantity',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Unit',
    colId: 'unit',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Unit Price',
    colId: 'unitCost',
    width: 120,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Multiplier',
    colId: 'multiplier',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Total Price',
    colId: 'totalPrice',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Time Factor',
    colId: 'timeFactor',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Location Factor',
    colId: 'locationFactor',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Construction Quality Factor',
    colId: 'constructionQualityFactor',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Condition Factor',
    colId: 'conditionFactor',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Soft Cost',
    colId: 'softCost',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'RCN',
    colId: 'rcn',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'RCNLD',
    colId: 'rcnld',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Avoid Variance',
    colId: 'avoidVariance',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Variance Factor',
    colId: 'varianceFactor',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Allocated Cost',
    colId: 'allocatedCost',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
]

export const projectColumns = [
  {
    aggFunc: null,
    colId: 'display',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: '0',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: 'isLocked',
    flex: null,
    hide: false,
    pinned: 'left',
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    aggFunc: null,
    colId: '1',
    flex: null,
    hide: false,
    pinned: null,
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 36,
    display: false,
  },
  {
    header: 'Asset Number',
    colId: 'assetNumber',
    width: 70,
    hide: false,
    pinned: null,
    sort: 'asc',
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Description',
    colId: 'assetDescription',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Suite #',
    colId: 'suite',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Tenant',
    colId: 'tenant',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Contract',
    colId: 'contract',
    width: 100,
    hide: false,
    pinned: null,
    sort: 'asc',
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Contract Name',
    colId: 'contractName',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Category Code',
    colId: 'categoryCode',
    width: 100,
    hide: false,
    pinned: null,
    sort: 'asc',
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Category Code Description',
    colId: 'categoryCodeDescription',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Asset Class',
    colId: 'assetClass',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Life',
    colId: 'life',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Takeoff Grouping',
    colId: 'takeoffGrouping',
    width: 200,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Group',
    colId: 'interiorGroup',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Additional Description',
    colId: 'additionalDescription',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Takeoff Description',
    colId: 'takeoff',
    width: 400,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Calculation',
    aggFunc: null,
    colId: 'calculation',
    flex: null,
    hide: false,
    pinned: null,
    pivot: false,
    pivotIndex: null,
    rowGroup: false,
    rowGroupIndex: null,
    sort: null,
    sortIndex: null,
    width: 100,
    display: true,
  },
  {
    header: 'Quantity',
    colId: 'quantity',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Group Quantity',
    colId: 'groupQuantity',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Unit',
    colId: 'unit',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Unit Price',
    colId: 'unitCost',
    width: 120,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Multiplier',
    colId: 'multiplier',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Total Price',
    colId: 'totalPrice',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Time Factor',
    colId: 'timeFactor',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Location Factor',
    colId: 'locationFactor',
    width: 80,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Construction Quality Factor',
    colId: 'constructionQualityFactor',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Condition Factor',
    colId: 'conditionFactor',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Soft Cost',
    colId: 'softCost',
    width: 100,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'RCN',
    colId: 'rcn',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'RCNLD',
    colId: 'rcnld',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Avoid Variance',
    colId: 'avoidVariance',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Variance Factor',
    colId: 'varianceFactor',
    width: 70,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
  {
    header: 'Allocated Cost',
    colId: 'allocatedCost',
    width: 150,
    hide: false,
    pinned: null,
    sort: null,
    sortIndex: null,
    aggFunc: null,
    rowGroup: false,
    rowGroupIndex: null,
    pivot: false,
    pivotIndex: null,
    flex: null,
    display: true,
  },
]

export const calculations = [
  'ASH - Average Story Height',
  'NB - Number of Building',
  'NS - Number of Stories',
  'PERB - Perimeter (Building Footprint)',
  'PERG - Perimeter (Grouping)',
  'PERS - Perimeter (Site)',
  'PERT - Perimeter (Tenant)',
  'SFB - Area (Total Building)',
  'SFG - Area (Grouping)',
  'SFR - Area (Building Footprint)',
  'SFS - Area (Site)',
  'SFT - Area (Tenant Unit)',
]

export const createRequest = (requestKeys, editFields, updateFields) => {
  let valid = false
  const request = {}
  requestKeys.map(element => {
    if (editFields[element] !== updateFields[element]) {
      valid = true
      Object.assign(request, { [element]: updateFields[element] })
    }
  })
  return { isValid: valid, request: request }
}

export const analysisSheetKeys = {
  asset_Class: 'assetClass',
  Asset_Class: 'assetClass',
  avoid_Variance: 'avoidVariance',
  Category_Code: 'categoryCode',
  category_Code: 'categoryCode',
  category_Code_Description: 'categoryCodeDescription',
  condition_Factor: 'conditionFactor',
  construction_Quality_Factor: 'constructionQualityFactor',
  contract_Name: 'contractName',
  interiorGrouping: 'interiorGroup',
  interior_Grouping: 'interiorGroup',
  location_Factor: 'locationFactor',
  Original_Description: 'originalDescription',
  soft_Cost: 'softCost',
  time_Factor: 'timeFactor',
  unit_Cost: 'unitCost',
}

export const replaceKeys = editedFields => {
  const keys = Object.keys(analysisSheetKeys)
  const updatedFields = []
  editedFields.forEach(element => {
    const key = keys.find(i => i === element)
    if (key) {
      updatedFields.push(analysisSheetKeys[element])
    } else {
      updatedFields.push(element)
    }
  })
  return JSON.stringify(updatedFields)
}

export const updateSideBarDetails = (
  taxLife,
  assetClass,
  taxLifeList,
  assetClassList,
) => {
  const taxList = taxLife
  const assetList = assetClass
  let assetDetails = []
  if (taxList.length > 0 && assetList.length > 0) {
    if (taxLifeList.length > 0 && assetClassList.length > 0) {
      taxList.forEach(element => {
        const index = taxLifeList.findIndex(i => i.id === element.Id)
        if (index > -1) {
          taxLifeList[index].name = element.Name
          taxLifeList[index].costBasis = Number(
            isNaN(element.CostBasis) ? 0 : element.CostBasis,
          )
          taxLifeList[index].assetDetails = []
          element.AssetDetails.forEach(element => {
            taxLifeList[index].assetDetails.push({
              life: element.Life,
              allocatedCost: element.AllocatedCost ? element.AllocatedCost : 0,
            })
          })
        }
      })
      assetList.forEach(element => {
        const index = assetClassList.findIndex(i => i.id === element.Id)
        if (index > -1) {
          assetClassList[index].name = element.Name
          assetClassList[index].costBasis = Number(
            isNaN(element.CostBasis) ? 0 : element.CostBasis,
          )
          assetClassList[index].assetDetails = []
          element.AssetDetails.forEach(element => {
            assetClassList[index].assetDetails.push({
              assetClass: element.AssetClass,
              allocatedCost: element.AllocatedCost ? element.AllocatedCost : 0,
            })
          })
        }
      })
    } else {
      taxList.forEach(element => {
        assetDetails = []
        element.costBasis = Number(
          isNaN(element.CostBasis) ? 0 : element.CostBasis,
        )
        element.AssetDetails.forEach(element => {
          assetDetails.push({
            life: element.Life,
            allocatedCost: element.AllocatedCost ? element.AllocatedCost : 0,
          })
        })
        taxLifeList.push({
          name: element.Name,
          costBasis: element.costBasis,
          assetDetails: assetDetails,
        })
      })

      assetList.forEach(element => {
        assetDetails = []
        element.costBasis = Number(
          isNaN(element.CostBasis) ? 0 : element.CostBasis,
        )
        element.AssetDetails.forEach(element => {
          assetDetails.push({
            assetClass: element.AssetClass,
            allocatedCost: element.AllocatedCost ? element.AllocatedCost : 0,
          })
        })
        assetClassList.push({
          name: element.Name,
          costBasis: element.costBasis,
          assetDetails: assetDetails,
        })
      })
    }
  }
  return {
    taxLifeList,
    assetClassList,
  }
}

export const checkEvents = eventType => {
  const events = [
    socketEvents.areaofTotalBuilding,
    socketEvents.areaofBuildingFootprint,
    socketEvents.tenantSFUpdated,
    socketEvents.averageStoryHeightUpdated,
    socketEvents.perimeterBuildingFootprintUpdated,
    socketEvents.numberofStoriesUpdated,
    socketEvents.projectTenantInfoDeleted,
    socketEvents.constructionQualityFactorUpdated,
    socketEvents.conditionFactorUpdated,
    socketEvents.templateInteriorGroupDeleted,
    socketEvents.areaUpdated,
    socketEvents.perimeterUpdated,
    socketEvents.templateTakeoffDetailsUpdated,
    socketEvents.projectTakeoffDetailsUpdated,
    socketEvents.CloneTenant,
  ]
  if (events.includes(eventType)) {
    return true
  }
  return false
}

export const checkLinkAssetEvents = eventType => {
  const events = [
    socketEvents.linkMethodUpdated,
    socketEvents.linkAsset,
    socketEvents.unlinkedAsset,
  ]
  if (events.includes(eventType)) {
    return true
  }
  return false
}

export const checkSidebarEvents = eventType => {
  const events = [
    socketEvents.templateSideBarUpdated,
    socketEvents.projectSidebarUpdated,
  ]
  if (events.includes(eventType)) {
    return true
  }
  return false
}

export const checkAssetDetailsEvents = eventType => {
  const events = [
    socketEvents.pisDateUpdated,
    socketEvents.locationFactorUpdated,
  ]
  if (events.includes(eventType)) {
    return true
  }
  return false
}

export const checkFiles = fileType => {
  const fileTypes = [
    'xlsx',
    'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ]
  if (fileTypes.includes(fileType)) {
    return true
  }
  return false
}

export const formatKeys = (result, keys) => {
  const formatJSON = {}

  Object.keys(keys).forEach(element => {
    Object.assign(formatJSON, {
      [element]: result ? result[element] : undefined,
    })
  })

  return formatJSON
}

export const apiRequest = (requestDetails, index) => {
  let request = {}

  switch (requestDetails.key) {
    case 'contract':
      request = {
        mContractId: requestDetails.contract ? requestDetails.contract.id : null,
      }
      break
    case 'categoryCode':
      request = {
        mCategoryCodeId: requestDetails.categoryCode
          ? requestDetails.categoryCode.id
          : null,
        mContractId: requestDetails.categoryCode
          ? requestDetails.categoryCode.contractDetailsId
          : undefined,
      }
      break
    case 'calculation':
      request = {
        calculation: requestDetails.value,
        quantity:
          evaluateQantity(requestDetails.record.formula) > 0
            ? evaluateQantity(requestDetails.record.formula)
            : null,
        isCalculationMatched: true,
      }
      break
    case 'takeoff':
      if (requestDetails.takeoff) {
        if (requestDetails.takeoff.id) {
          request = {
            mContractId: requestDetails.takeoff.mContractDetailsId,
            mCategoryCodeId: requestDetails.takeoff.mCategoryCodeId,
            mUnitId: requestDetails.takeoff.mUnitId,
            mTakeoffId: requestDetails.takeoff.id,
            mTakeoffGroupingId: requestDetails.takeoff.takeoffGroupingId,
            takeoff: requestDetails.takeoff.takeoff,
            unitCost: requestDetails.takeoff.unitCost,
            source: requestDetails.takeoff.source,
            isApplicationMaster: false,
          }
        } else {
          request = {
            mTakeoffId: requestDetails.takeoff.takeoffId,
            mTakeoffGroupingId: requestDetails.takeoff.takeoffGroupingId,
            takeoff: requestDetails.takeoff.takeoff,
            unitCost: requestDetails.takeoff.unitCost,
            source: requestDetails.takeoff.source,
            isApplicationMaster: true,
          }
        }
      } else {
        request = {
          takeoff: requestDetails.value,
        }
      }
      break
    case 'unit':
      request = {
        mUnitId: requestDetails.unit ? requestDetails.unit.id : null,
      }
      break
    case 'quantity':
      let isCalculationMatched = false
      if (
        requestDetails.record.formula &&
        requestDetails.value &&
        evaluateQantity(requestDetails.record.formula) ===
          Number(requestDetails.value)
      ) {
        isCalculationMatched = true
      }
      request = {
        quantity: requestDetails.value > 0 ? requestDetails.value : null,
        isCalculationMatched: isCalculationMatched,
      }
      break
    case 'costType':
      request = {
        mCostTypeId: requestDetails.costType ? requestDetails.costType.id : null,
      }
      break
    default:
      request = {
        [requestDetails.key]: requestDetails.value || null,
      }
      break
  }

  return request
}

export const costMethod = [
  {
    id: 1,
    costMethod: 'N/A',
    costType: [4, 5, 6, 7],
  },
  {
    id: 2,
    costMethod: 'U',
    costType: [1, 2, 3],
  },
]

export const apiRequestArray = (requestDetails, index) => {
  const request = []

  requestDetails.selectedKeys.forEach(element => {
    switch (requestDetails.key) {
      case 'contract':
        request.push({
          id: element,
          mContractId: requestDetails.contract
            ? requestDetails.contract.id
            : null,
          isManuallyUpdated: requestDetails.record.isAdjustmentTakeoff
            ? true
            : undefined,
        })
        break
      case 'categoryCode':
        request.push({
          id: element,
          mCategoryCodeId: requestDetails.categoryCode
            ? requestDetails.categoryCode.id
            : null,
          mContractId: requestDetails.categoryCode
            ? requestDetails.categoryCode.contractDetailsId
            : undefined,
          isManuallyUpdated: requestDetails.record.isAdjustmentTakeoff
            ? true
            : undefined,
        })
        break
      case 'takeoff':
        if (requestDetails.takeoff) {
          if (requestDetails.takeoff.id) {
            request.push({
              id: element,
              mContractId: requestDetails.takeoff.mContractDetailsId,
              mCategoryCodeId: requestDetails.takeoff.mCategoryCodeId,
              mUnitId: requestDetails.takeoff.mUnitId,
              mTakeoffId: requestDetails.takeoff.id,
              mTakeoffGroupingId: requestDetails.takeoff.takeoffGroupingId,
              takeoff: requestDetails.takeoff.takeoff,
              source: requestDetails.takeoff.source,
              isApplicationMaster: false,
              unitCost: requestDetails.takeoff.unitCost,
            })
          } else {
            request.push({
              id: element,
              mTakeoffId: requestDetails.takeoff.takeoffId,
              mTakeoffGroupingId: requestDetails.takeoff.takeoffGroupingId,
              takeoff: requestDetails.takeoff.takeoff,
              source: requestDetails.takeoff.source,
              isApplicationMaster: true,
              unitCost: requestDetails.takeoff.unitCost,
            })
          }
        } else {
          request.push({
            id: element,
            takeoff: requestDetails.value,
          })
        }
        break
      case 'calculation':
        request.push({
          id: element,
          calculation: requestDetails.value,
          quantity:
            evaluateQantity(requestDetails.record.formula) > 0
              ? evaluateQantity(requestDetails.record.formula)
              : null,
          isCalculationMatched: true,
        })
        break
      case 'unit':
        request.push({
          id: element,
          mUnitId: requestDetails.unit ? requestDetails.unit.id : null,
        })
        break
      case 'quantity':
        let isCalculationMatched = false
        if (
          requestDetails.record.formula &&
          requestDetails.value &&
          evaluateQantity(requestDetails.record.formula) ===
            Number(requestDetails.value)
        ) {
          isCalculationMatched = true
        }
        request.push({
          id: element,
          quantity: requestDetails.value > 0 ? requestDetails.value : null,
          isCalculationMatched: isCalculationMatched,
        })
        break
      case 'costType':
        let costmethod, isPresent, categoryCodeId
        if (requestDetails.costType && requestDetails.costType.id) {
          costmethod = costMethod.find(i =>
            i.costType.includes(requestDetails.costType.id),
          )
          isPresent = costTypes.includes(requestDetails.costType.id)
          categoryCodeId = requestDetails.record.mCategoryCodeId
        } else {
          categoryCodeId = null
        }
        request.push({
          id: element,
          mCostTypeId: requestDetails.costType
            ? requestDetails.costType.id
            : null,
          mCostMethodId: costmethod ? costmethod.id : null,
          costMethod: costmethod ? costmethod.costMethod : null,
          mCategoryCodeId: isPresent ? null : categoryCodeId,
          isManuallyUpdated: requestDetails.record.isAdjustmentTakeoff
            ? true
            : undefined,
        })
        break
      case 'tileName':
        request.push({
          id: element,
          childTileId: requestDetails.tile ? requestDetails.tile.id : null,
        })
        break
      case 'constructionQualityFactor':
        request.push({
          id: element,
          constructionQualityFactorId:
            requestDetails.constructionQualityFactor.id,
          constructionQualityFactor:
            requestDetails.constructionQualityFactor.value,
        })
        break
      case 'unitCost':
        if (requestDetails.screen === 'Actual Cost') {
          let costDetails = requestDetails.selectedRows.find(
            i => i.id === element,
          )
          costDetails =
            requestDetails.selectedRows.length === 0
              ? requestDetails.record
              : costDetails
          const isNegative = requestDetails.value && requestDetails.value < 0
          const isCostType =
            costDetails && hardCostTypes.includes(costDetails.mCostTypeId)
          const isAdjustmentTakeoff =
            costDetails && costDetails.isAdjustmentTakeoff
          if (isCostType && isNegative && !isAdjustmentTakeoff) {
            request.push({
              id: element,
              [requestDetails.key]: requestDetails.value || null,
              mCategoryCodeId: null,
              mContractId: null,
              mCostTypeId: null,
              mCostMethodId: null,
              costMethod: null,
            })
          } else {
            request.push({
              id: element,
              [requestDetails.key]: requestDetails.value || null,
            })
          }
        } else {
          request.push({
            id: element,
            [requestDetails.key]: requestDetails.value || null,
          })
        }
        break
      default:
        request.push({
          id: element,
          [requestDetails.key]: requestDetails.value || null,
        })
        break
    }
  })

  return request
}

export const validateNumber = (value, key, name, record) => {
  let reg
  let title = 'Validation'
  const header = name
  const isCheck = key === 'unitCost' && name === 'Actual Cost'
  const isNegative = value && value < 0
  const isCostType = record && hardCostTypes.includes(record.mCostTypeId)
  let isError = false
  let maxValue
  let minValue
  let format
  switch (key) {
    case 'area':
    case 'areaTotalBuilding':
    case 'areaBuildingFootprint':
    case 'tenantSF':
    case 'sf':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 1234567)'
      maxValue = 9999999
      break
    case 'numberOfBuilding':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 123)'
      maxValue = 999
      minValue = 1
      break
    case 'averageStoryHeight':
    case 'numberOfStories':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 123)'
      maxValue = 999
      break
    case 'softCosts':
    case 'softCost':
      reg = /^(?!$)\d{1,9}(?:\.\d{1,2})?$/
      format = '(e.g.: 123.12)'
      maxValue = 999.99
      minValue = 0
      break
    case 'bonusPercentage':
      reg = /^(?!$)\d{1,9}(?:\.\d{1,2})?$/
      format = '(e.g.: 123.12)'
      maxValue = 100
      minValue = 0
      break
    case 'clientAssetNumber':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 1234567)'
      maxValue = 1000000
      break

    case 'perimeterBuildingFootprint':
    case 'perimeter':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 12345)'
      maxValue = 99999
      break
    case 'totalSiteArea':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 12345678901)'
      maxValue = 99999999999
      break
    case 'multiplier':
      reg = /^(?!$)\d{0,9}(?:\.\d{1,3})?$/
      format = '(e.g.: 1.234)'
      maxValue = 9.999
      minValue = 0.001
      break
    case 'quantity':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 1234567)'
      maxValue = 9999999
      minValue = 1
      break
    case 'locationFactor':
      reg = /^(?!$)\d{1,9}(?:\.\d{1,3})?$/
      format = '(e.g.: 1.234)'
      maxValue = 9.999
      minValue = 0.001
      break
    case 'costBasis':
      reg = /^(?!$)\d{0,10}(?:\.\d{1,2})?$/
      format = '(e.g.: 1234567890.12)'
      maxValue = 9999999999.0
      minValue = 0.01
      break
    case 'unitCost':
      reg = /^-?(?!$)\d{0,13}(?:\.\d{1,2})?$/
      format = '(e.g.: 1234567891234.12)'
      maxValue = 9999999999999.99
      if (name !== 'Actual Cost') {
        reg = /^(?!$)\d{0,13}(?:\.\d{1,2})?$/
        minValue = 0.01
      }
      break
    case 'constructionQualityFactor':
    case 'conditionFactor':
      reg = /^(?!$)\d{0,9}(?:\.\d{1,2})?$/
      format = '(e.g.: 1.12)'
      maxValue = 9.99
      minValue = 0.01
      break
    case 'timeFactor':
      reg = /^(?!$)\d{0,9}(?:\.\d{1,4})?$/
      format = '(e.g.: 1.123)'
      maxValue = 9.9999
      minValue = 0.0001
      break
    case 'groupQuantity':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 1234)'
      maxValue = 9999
      break
    case 'projectNumber':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 123456789)'
      break
    case 'value':
      reg = /^\d*(d+)?$/
      format = '(e.g.: 1234)'
      maxValue = 9999
      minValue = 1
      break
    default:
      break
  }

  if (key === 'quantity' && (!value || value <= 0)) {
    title = `${header.charAt(0).toUpperCase() +
      header.slice(1)} must be greater than 0`
    showNotification('warning', header, title)
  } else if (isCheck && isCostType && isNegative) {
    title = `${header.charAt(0).toUpperCase() +
      header.slice(1)} must be greater than or equals to ${formatNumber(
      minValue,
    )} for ${record.costType}`
    showNotification('warning', header, title, true)
    return { title: title }
  } else if (key === 'costType') {
    if (hardCostTypes.includes(value) && record && record.unitCost < 0) {
      title = `You can not select any hard cost type for negative cost line item`
      isError = true
    }
  } else if ((value || value === 0) && maxValue && value > maxValue) {
    title = `${header.charAt(0).toUpperCase() +
      header.slice(1)} must be less than or equals to ${formatNumber(
      maxValue,
    )}`
    isError = true
  } else if ((value || value === 0) && minValue && value < minValue) {
    title = `${header.charAt(0).toUpperCase() +
      header.slice(1)} must be greater than or equals to ${formatNumber(
      minValue,
    )}`
    isError = true
  } else if ((value || value === 0) && reg && !reg.test(value)) {
    title = `Please enter valid ${header.toLowerCase()} ${format}`
    isError = true
  }
  if (isError) {
    showNotification('warning', header, title)
    return false
  }
  return true
}

export const tableName = {
  templateDashboard: 'TemplateDashboard',
  projectDashboard: 'ProjectDashboard',
  projectRestore: 'ProjectRestore',
  template: {
    tenant: 'Tenant',
    takeoff: 'Takeoff',
    analysisSheet: 'AnalysisSheet',
    master: {
      takeoff: 'Takeoff',
      unit: 'Unit',
      bsuop: 'Bsuop',
      assetClass: 'AssetClass',
      contract: 'Contract',
      categoryCode: 'CategoryCode',
    },
  },
  project: {
    asset: 'Asset',
    tenant: 'Tenant',
    newConstTenant: 'NewConstTenant',
    takeoff: 'Takeoff',
    analysisSheet: 'AnalysisSheet',
    master: {
      takeoff: 'Takeoff',
      unit: 'Unit',
      bsuop: 'Bsuop',
      assetClass: 'AssetClass',
      contract: 'Contract',
      categoryCode: 'CategoryCode',
    },
  },
}

export const rolePermissions = {
  saveAsTemplate: [
    'Admin',
    'Engagement Manager',
    'Project Manager',
    'Project Reviewer',
  ],
  saveAsGroupingBank: ['Admin', 'Engagement Manager', 'Project Reviewer'],
  saveAsTenantBank: ['Admin', 'Engagement Manager', 'Project Reviewer'],
}

export const checkRole = () => {
  const user = JSON.parse(localStorage.getItem('userDetails'))
  if (user) {
    return user.role !== 'Admin'
  }
  return true
}

export const costTypes = [4, 5, 6, 7]

export const hardCostTypes = [1, 2, 3]

export const reportSummary = [
  {
    type: 'Acquistion',
    description:
      "*Some of the takeoff's are invalid due to missing required properties. Please make sure you have populated all the required properties of the takeoff's before previewing or generating the report.",
  },
  {
    type: 'IndirectTakeoffs',
    description:
      '*Please allocate custom indirect to line items before proceeding.',
  },
  {
    type: 'ActualCostTakeoffs',
    description: '*Please match Cost Basis and Actual cost before proceeding.',
  },
  {
    type: 'AssetClassChanged',
    description:
      '*Please re-apply Asset Class changes before previewing or generating reports.',
  },
  {
    type: 'IRC481',
    description:
      '**Required fields for generating IRC 481(a) - Adjustment Summary are missing. Please make sure you have populated all the required fields before generating the IRC 481(a) - Adjustment Summary.',
  },
]

export const checkFields = ['costType', 'contract', 'categoryCode', 'takeoff']

export const checkUrls = [
  'dropdown/users',
  'dropdown',
  'master/tenantType/list',
  'master/bank/tenant/list',
  'table-column-setting',
  'reconcile',
  'master/unit/list',
  'master/BSUOP/list',
  'master/asset-class/list',
  'master/contract/list',
  'master/category-code/list',
  'master/takeoff/list',
  'master/takeoff-grouping/list',
  'projects/time-log',
]
